import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractCRUD, CRUDService, ExceptionService, UtilsService } from '../../xform-compat';
import { EventType } from '../../shared/models';
import { catchError } from 'rxjs/operators';


/**
 * Data service to get event types
 */
@Injectable({
  providedIn: 'root'
})
export class EventTypesService extends AbstractCRUD<EventType> implements CRUDService<EventType> {

  constructor(
    http: HttpClient,
    exceptionService: ExceptionService,
    utilsService: UtilsService
  ) {
    super(exceptionService, http, utilsService);
  }

  getResourcePath () {
    return '/measures/eventtypes';
  }

  /**
   * Get a list of event types available for the given entity
   * @param params
   */
  public getEventTypesByEntity(params: any): Observable<Array<EventType>> {
    const url = '/api/measures/eventlogs/eventtypes';
    return super.getHTTP()
      .get(url, {params: params})
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }
}
